/**
 * Neckvera — Cart expiration timer
 * Upload to: Assets → cart-expiry-timer.js
 * Load it on every page (theme.liquid, right after cart-drawer.js) with:
 *   {{ 'cart-expiry-timer.js' | asset_url | script_tag }}
 *
 * Behavior:
 * - When the cart goes from empty to having items, a 20-minute deadline is set.
 * - Any successful /cart/add, /cart/change, or /cart/update call resets the deadline
 *   (so an active shopper never gets cut off mid-shop).
 * - A countdown renders into any element with id="NV-CartTimer" (place one in your
 *   cart-drawer.liquid — see the snippet at the bottom of this file's README section).
 * - At 00:00 the cart is cleared via /cart/clear.js and the drawer + cart icon are
 *   re-rendered so the UI reflects the empty cart immediately, no page reload needed.
 */
(function () {
  var CART_TIMER_KEY = 'nv_cart_expires_at';
  var CART_DURATION_MS = 20 * 60 * 1000; // 20 minutes
  var tickHandle = null;

  function getDeadline() {
    var stored = localStorage.getItem(CART_TIMER_KEY);
    return stored ? parseInt(stored, 10) : null;
  }

  function setDeadline() {
    var deadline = Date.now() + CART_DURATION_MS;
    localStorage.setItem(CART_TIMER_KEY, deadline.toString());
    return deadline;
  }

  function clearDeadline() {
    localStorage.removeItem(CART_TIMER_KEY);
  }

  function renderExpiredMessage() {
    var el = document.getElementById('NV-CartTimer');
    if (el) {
      el.textContent = 'Your cart has expired and was cleared.';
      el.classList.add('nv-cart-timer--expired');
    }
  }

  function render(deadline) {
    var el = document.getElementById('NV-CartTimer');
    var remaining = deadline - Date.now();

    if (remaining <= 0) {
      if (tickHandle) clearInterval(tickHandle);
      emptyCart();
      return;
    }

    if (el) {
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000).toString().padStart(2, '0');
      el.textContent = 'Items reserved for ' + mins + ':' + secs;
      el.classList.remove('nv-cart-timer--expired');
    }
  }

  function startTicking(deadline) {
    if (tickHandle) clearInterval(tickHandle);
    if (!deadline) return;
    render(deadline);
    tickHandle = setInterval(function () { render(deadline); }, 1000);
  }

  function refreshCartSections() {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var params = sections.map(function (s) { return 'section_id=' + s; }).join('&');

    return fetch(window.location.pathname + '?' + params)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        sections.forEach(function (id) {
          var target = document.getElementById(id);
          var source = html.getElementById(id);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      });
  }

  function emptyCart() {
    clearDeadline();
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(refreshCartSections)
      .then(function () {
        renderExpiredMessage();
        document.dispatchEvent(new CustomEvent('nv:cart-expired'));
      })
      .catch(function (err) { console.error('Cart auto-clear failed:', err); });
  }

  // Resume an existing countdown on page load (survives navigation/refresh)
  var existingDeadline = getDeadline();
  if (existingDeadline) startTicking(existingDeadline);

  // Reset / start the timer whenever the cart actually changes.
  // Hooking fetch (rather than specific buttons) means this keeps working
  // no matter which theme block triggers the add/update.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = args[0] instanceof Request ? args[0].url : args[0];
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);

    return originalFetch.apply(this, args).then(function (response) {
      if (isCartMutation && response.ok) {
        response.clone().json().then(function (data) {
          var itemCount = (typeof data.item_count === 'number') ? data.item_count
            : (data.items ? data.items.length : null);

          if (itemCount === 0) {
            clearDeadline();
            if (tickHandle) clearInterval(tickHandle);
            var el = document.getElementById('NV-CartTimer');
            if (el) el.textContent = '';
          } else if (itemCount > 0) {
            startTicking(setDeadline());
          }
        }).catch(function () {});
      }
      return response;
    });
  };
})();
